import React, { memo } from 'react';
import { useTaskDetailsEdit } from './useTaskDetailsEdit';
import { Col, DatePicker, Form, FormModal, Row, Select } from 'components';
import { AdminsSelect } from 'components/common/adminsSelect';
import { AllEntityTypes, PriorityTypes } from 'models/Task';
import { EntityValue } from 'components/common/tasks';
import dayjs from 'dayjs';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export interface ITaskDetailsUpdate {
  onCancel: () => void;
  open?: boolean;
}

export const TaskEditModal = memo<ITaskDetailsUpdate>((props) => {
  const [form] = Form.useForm();
  const { onCancel, open } = props;
  const { hasAccess } = useAccessControl();

  const { onFinish, contextHolder, isSaveBtnDisabled, checkErrors, onCancelModal, isLoading } = useTaskDetailsEdit({
    onCancel,
    form,
    open,
  });

  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        title={'Update Task Details'}
        okText={'Save'}
        open={open}
        isLoading={isLoading}
        disableOkBtn={isSaveBtnDisabled}
        onValuesChange={checkErrors}
        onCancel={onCancelModal}
        onSubmit={onFinish}
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="Assign To*" name="assignedTo" rules={[{ required: true }]}>
              <AdminsSelect size={'large'} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Priority*" name="priorityLevel" rules={[{ required: true }]} initialValue="Medium">
              <Select size={'large'} options={PriorityTypes} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Entity" name="entityType">
              <Select
                size={'large'}
                placeholder="Select entity"
                options={Object.values(AllEntityTypes).filter((i) => hasAccess(i.permission))}
              />
            </Form.Item>
          </Col>

          <Form.Item noStyle shouldUpdate={(prev, curr) => prev.entityType !== curr.entityType}>
            {({ getFieldValue }) => {
              const entity = getFieldValue('entityType');
              return (
                <Col span={12}>
                  <EntityValue entity={entity} />
                </Col>
              );
            }}
          </Form.Item>
          <Col span={12}>
            <Form.Item label="Due Date*" name="dueDate" rules={[{ required: true, message: 'Please select due date' }]}>
              <DatePicker
                size={'large'}
                showTime={{ format: 'HH:mm', defaultValue: dayjs('00:00', 'HH:mm'), showSecond: false }}
                format="YYYY-MM-DD HH:mm"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
        </Row>
      </FormModal>
    </>
  );
});
